import axios from '../axios';

import type { MailBody } from '../../../pages/api/mail';
import type { AxiosResponse } from 'axios';


export const postMail = async (data: MailBody): Promise<AxiosResponse<MailBody>> => {
  const res = await axios.post('/api/mail', data, { timeout: 2000 } );

  return res;
};
